import React from 'react';
import { X } from 'lucide-react';

export function LegalModal({ t, legalModal, setLegalModal }) {
  if (!legalModal) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" onClick={() => setLegalModal(null)}>
      <div className="bg-slate-900 border border-slate-700 rounded-2xl max-w-2xl w-full max-h-[80vh] flex flex-col" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-700">
          <h2 className="text-lg font-semibold">
            {legalModal === 'privacy' ? t('privacyPolicy') : t('termsConditions')}
          </h2>
          <button onClick={() => setLegalModal(null)} className="text-slate-400 hover:text-white transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="px-6 py-4 overflow-y-auto text-sm text-slate-300 leading-relaxed whitespace-pre-line">
          {legalModal === 'privacy' ? t('privacyContent') : t('termsContent')}
        </div>
        <div className="px-6 py-4 border-t border-slate-700 flex justify-end">
          <button onClick={() => setLegalModal(null)} className="bg-emerald-500 hover:bg-emerald-600 px-4 py-2 rounded-lg text-sm font-medium transition-colors">
            {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LegalModal;
